class UseRecaptchaService {
  private static readonly siteKey: string =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  static isEnabled(): boolean {
    return Boolean(this.siteKey);
  }
}

export default UseRecaptchaService;
